import { Injectable } from '@angular/core';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})
export class RegisterInforService {
  userId = '';
  clientId = environment.clientId;
  tokenHash = '';
  pinCode = '';
  email = '';
  customerType = null;
  portalId = '';
  parentType: Number;
}
